export * from './fonts';

//# sourceMappingURL=index.js.map